<form [formGroup]="formGroup">
    <h5>{{ context.node.name.key | translateTokenisedString }}</h5>
    @switch (context.node.nodeType) {
        @case (WorkflowNodeType.LogicStep) {
            @if (context.parameters?.length > 0) {
                <clmi-workflow-designer-parameter-group
                    [parameters]="context.parameters"
                    [formGroup]="formGroup"
                    [addCollectionItem]="addCollectionItem.bind(this)"
                    [removeCollectionItem]="removeCollectionItem.bind(this)"
                    [componentProvider]="componentProvider"
                />
            } @else {
                <p>no parameters found</p>
            }
        }
        @case (WorkflowNodeType.Query) {
            <clmi-workflow-designer-parameter-query
                [formGroup]="formGroup"
                [node]="context.node"
            />
        }
    }
</form>
